<template>
  <div class="container">
    <el-row>
      <el-col :span="3">
        <cma-catalog :site-type="this.site_type" :project-id="this.project_id" :site-id="this.site_id"
          :rr-type="this.rr_type" title="原始记录（CMA）" :route-name="'site_' + this.site_type + '_list'"></cma-catalog>
      </el-col>
      <el-col :span="21">
        <span v-if="inspect_status">
          <el-button size="mini" type="success" @click="handleSubmit">保存</el-button>
          <!-- <el-button size="mini" type="primary" @click="initRecord">新增一页</el-button> -->
          <!-- <el-button size="mini" type="primary" @click="copyLast">复制上一页</el-button> -->
          <el-upload class="upload-demo btn inline-block" name="upload_file" :on-success="uploadSuccess1"
            :show-file-list="false" action="https://dq-back.wzfire.com/upload_file" :headers="headers" :multiple="false"
            :before-upload="beforeUpload" accept=".jpeg,.jpg,.png" :data="uploadData">
            <el-button type="primary" size="mini" style="margin-bottom: 10px;">上传原图</el-button>
          </el-upload>
          <el-upload class="upload-demo btn inline-block" name="upload_file" :on-success="uploadSuccess2"
            :show-file-list="false" action="https://dq-back.wzfire.com/upload_file" :headers="headers" :multiple="false"
            :before-upload="beforeUpload" accept=".jpeg,.jpg,.png" :data="uploadData">
            <el-button type="primary" size="mini" style="margin-bottom: 10px;">上传分析图</el-button>
          </el-upload>
          <!-- <el-button type="primary" size="mini" @click="handleSetDefault">设置设备和环境默认值</el-button> -->
          <!-- <el-button type="primary" size="mini" @click="handleGetDefault">获取环境默认值</el-button> -->
          <el-button type="danger" size="mini" @click="handleDel">删除当前页</el-button>
        </span>
        <el-select v-model="currentPage" @change="handleChange" placeholder="请选择页数" size="mini"
          style="margin-left: 15px;">
          <el-option v-for="item in pages" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-form style="margin: 0" ref="form" :model="form" :inline="true" size="mini">
          <table>
            <tr>
              <td colspan="9" style="text-align: center">3.1.1检测结果/数据</td>
            </tr>
            <tr>
              <td>环境温度（℃）</td>
              <td colspan="2">
                <el-input v-model="form.hjwd"></el-input>
              </td>
              <td>环境湿度（%RH）</td>
              <td colspan="2">
                <el-input v-model="form.hjsd"></el-input>
              </td>
              <td>风速（m/s）</td>
              <td colspan="2">
                <el-input v-model="form.fs"></el-input>
              </td>
            </tr>
            <tr>
              <td>辐射系数</td>
              <td colspan="2">
                <el-input v-model="form.fsxs"></el-input>
              </td>
              <td>额定电压（V）</td>
              <td colspan="2">
                <el-input v-model="form.eddy"></el-input>
              </td>
              <td>额定电流（A）</td>
              <td colspan="2">
                <el-input v-model="form.eddl"></el-input>
              </td>
            </tr>
            <tr>
              <td><span style="color: red">被检测设备位置</span></td>
              <td colspan="2">
                <el-input v-model="form.bjcsbwz"></el-input>
              </td>
              <td><span style="color: red">被检测设备名称</span></td>
              <td colspan="2">
                <el-input v-model="form.bjcsbmc"></el-input>
              </td>
              <td>型号规格</td>
              <td colspan="2">
                <el-input v-model="form.xhgg"></el-input>
              </td>
            </tr>
            <tr>
              <td>电压值（V）</td>
              <td>A-B</td>
              <td>
                <el-input v-model="form.dy_ab"></el-input>
              </td>
              <td>A-C</td>
              <td>
                <el-input v-model="form.dy_ac"></el-input>
              </td>
              <td>B-C</td>
              <td>
                <el-input v-model="form.dy_bc"></el-input>
              </td>
              <td>L-N</td>
              <td>
                <el-input v-model="form.dy_ln"></el-input>
              </td>
            </tr>
            <tr>
              <td colspan="3" style="text-align: center">数据/位置</td>
              <td colspan="2">A相</td>
              <td colspan="2">B相</td>
              <td>C相</td>
              <td>零线</td>
            </tr>
            <tr>
              <td rowspan="2" style="text-align: center">实测温度（℃）</td>
              <td colspan="2" style="text-align: center">进线</td>
              <td colspan="2">
                <el-input v-model="form.a_in"></el-input>
              </td>
              <td colspan="2">
                <el-input v-model="form.b_in"></el-input>
              </td>
              <td>
                <el-input v-model="form.c_in"></el-input>
              </td>
              <td>
                <el-input v-model="form.zero_in"></el-input>
              </td>
            </tr>
            <tr>
              <td colspan="2" style="text-align: center">出线</td>
              <td colspan="2">
                <el-input v-model="form.a_out"></el-input>
              </td>
              <td colspan="2">
                <el-input v-model="form.b_out"></el-input>
              </td>
              <td>
                <el-input v-model="form.c_out"></el-input>
              </td>
              <td>
                <el-input v-model="form.zero_out"></el-input>
              </td>
            </tr>
            <tr>
              <td colspan="3" style="text-align: center">负荷电流（A）</td>
              <td colspan="2">
                <el-input v-model="form.a_dl"></el-input>
              </td>
              <td colspan="2">
                <el-input v-model="form.b_dl"></el-input>
              </td>
              <td>
                <el-input v-model="form.c_dl"></el-input>
              </td>
              <td>
                <el-input v-model="form.zero_dl"></el-input>
              </td>
            </tr>
            <tr>
              <td>温升（K）</td>
              <td colspan="2">
                <el-input v-model="form.ws"></el-input>
              </td>
              <td>相对温差（%）</td>
              <td colspan="2">
                <el-input v-model="form.xdwc"></el-input>
              </td>
              <td>图像编号</td>
              <td colspan="2">
                <el-input v-model="form.txbh"></el-input>
              </td>
            </tr>
            <tr>
              <td>检测结果</td>
              <td colspan="4">
                <el-select v-model="form.jcjg" clearable placeholder="请选择结论" style="width: 100%;">
                  <el-option label="符合要求" value="符合要求"></el-option>
                  <el-option label="温度存在紧急缺陷" value="温度存在紧急缺陷"></el-option>
                  <el-option label="温度存在严重缺陷" value="温度存在严重缺陷"></el-option>
                  <el-option label="温度存在一般缺陷" value="温度存在一般缺陷"></el-option>
                </el-select>
              </td>
              <td colspan="2">
                隐患等级
              </td>
              <td colspan="2">
                {{ level }}
              </td>
            </tr>
            <tr>
              <td>原图</td>
              <td colspan="8" style="height: 500px;">
                <el-image :src="image1_src" lazy>
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </td>
            </tr>
            <tr>
              <td>分析图</td>
              <td colspan="9" style="height: 500px;">
                <el-image :src="image2_src">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </td>
            </tr>
            <tr>
              <td>备注</td>
              <td colspan="8">相对温差：δ=(T1-T2)/(T1-T0)
                ×100%，式中：T1—发热点的温升和温度；T2—正常相对应点的温升和温度；T0—被测设备区域的环境温度—气温。
              </td>
            </tr>
          </table>
        </el-form>
      </el-col>
    </el-row>
    <!--设备和环境-->
    <el-dialog title="设置设备和环境默认值" :visible.sync="defaultModel.show" width="800px" @close="onCloseDefault">
      <el-form :model="defaultModel" label-width="150px" size="small">
        <el-form-item label="检测仪器">
          <el-input v-model="defaultModel.yqmc1" disabled></el-input>
        </el-form-item>
        <el-form-item label="仪器编号+校准有效期">
          <el-select style="width: 100%" v-model="defaultModel.yqbh1jzyxq1" @change="yq1Change" placeholder="请选择">
            <el-option v-for="item in yq1Options" :key="item.value" :label="item.label" :value="item.value">
              <span style="float: left">{{ item.label | yq_spilt1(item.label) }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{
                item.label | yq_spilt2(item.label)
              }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="检测仪器">
          <el-input v-model="defaultModel.yqmc2" disabled></el-input>
        </el-form-item>
        <el-form-item label="仪器编号+校准有效期">
          <el-select style="width: 100%" v-model="defaultModel.yqbh2jzyxq2" @change="yq2Change" placeholder="请选择">
            <el-option v-for="item in yq2Options" :key="item.value" :label="item.label" :value="item.value">
              <span style="float: left">{{ item.label | yq_spilt1(item.label) }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{
                item.label | yq_spilt2(item.label)
              }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="检测仪器">
          <el-input v-model="defaultModel.yqmc3" disabled></el-input>
        </el-form-item>
        <el-form-item label="仪器编号+校准有效期">
          <el-select style="width: 100%" v-model="defaultModel.yqbh3jzyxq3" @change="yq3Change" placeholder="请选择">
            <el-option v-for="item in yq3Options" :key="item.value" :label="item.label" :value="item.value">
              <span style="float: left">{{ item.label | yq_spilt1(item.label) }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{
                item.label | yq_spilt2(item.label)
              }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="检测仪器">
          <el-input v-model="defaultModel.yqmc4" disabled></el-input>
        </el-form-item>
        <el-form-item label="仪器编号+校准有效期">
          <el-select style="width: 100%" v-model="defaultModel.yqbh4jzyxq4" @change="yq4Change" placeholder="请选择">
            <el-option v-for="item in yq4Options" :key="item.value" :label="item.label" :value="item.value">
              <span style="float: left">{{ item.label | yq_spilt1(item.label) }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{
                item.label | yq_spilt2(item.label)
              }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="环境温度（℃）">
          <el-input v-model="defaultModel.hjwd"></el-input>
        </el-form-item>
        <el-form-item label="环境湿度（%RH）">
          <el-input v-model="defaultModel.hjsd"></el-input>
        </el-form-item>
        <el-form-item label="风速（m/s）">
          <el-input v-model="defaultModel.fs"></el-input>
        </el-form-item>
        <el-form-item label="辐射系数">
          <el-input v-model="defaultModel.fsxs"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSetDefault">提交</el-button>
          <el-button type="info" @click="onCloseDefault">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";

let token = Vue.$Config.userinfo.token
export default {
  data() {
    return {
      headers: { Authorization: token },
      loading: false,
      inspect_status: false,
      uploadData: {
        project_id: '',
        site_id: '',
      },
      zg_type: 'cma_311',
      project_id: '',
      site_id: '',
      site_type: '',
      rr_type: 'record',
      pages: [],
      currentPage: 1,
      maxPage: 0,
      form: {
        hjwd: '',
        hjsd: '',
        fs: '',
        fsxs: '',
        eddy: '',
        eddl: '',
        bjcsbwz: '',
        bjcsbmc: '',
        xhgg: '',
        dy_ab: '',
        dy_ac: '',
        dy_bc: '',
        dy_ln: '',
        a_in: '',
        a_out: '',
        a_dl: '',
        b_in: '',
        b_out: '',
        b_dl: '',
        c_in: '',
        c_out: '',
        c_dl: '',
        zero_in: '',
        zero_out: '',
        zero_dl: '',
        ws: '',
        xdwc: '',
        txbh: '',
        image1_id: '',
        image2_id: '',
      },
      image1_src: '',
      image2_src: '',
      hideUpload1: false,
      hideUpload2: false,
      defaultModelShow: false,
      defaultModel: {
        show: false,
        yqmc1: '红外热成像仪',
        yqbh1: '',
        jzyxq1: '',
        yqmc2: '钳形电流表',
        yqbh2: '',
        jzyxq2: '',
        yqmc3: '数字风速仪',
        yqbh3: '',
        jzyxq3: '',
        yqmc4: '数字温湿度计',
        yqbh4: '',
        jzyxq4: '',
        yqbh1jzyxq1: '',
        yqbh2jzyxq2: '',
        yqbh3jzyxq3: '',
        yqbh4jzyxq4: '',
        fsxs: ''
      },
      yq1Options: [],
      yq2Options: [],
      yq3Options: [],
      yq4Options: []
    }
  },
  methods: {
    //change
    yq1Change(val) {
      this.defaultModel.yqbh1jzyxq1 = val
      this.$forceUpdate()
    },
    yq2Change(val) {
      this.defaultModel.yqbh2jzyxq2 = val
      this.$forceUpdate()
    },
    yq3Change(val) {
      this.defaultModel.yqbh3jzyxq3 = val
      this.$forceUpdate()
    },
    yq4Change(val) {
      this.defaultModel.yqbh4jzyxq4 = val
      this.$forceUpdate()
    },
    //设置设备和环境
    async handleSetDefault() {
      this.yq1Options = []
      this.yq2Options = []
      this.yq3Options = []
      this.yq4Options = []

      let yq1 = await this.$Api.post('get_device_info', {
        'device_name': this.defaultModel.yqmc1
      })
      yq1.forEach(item => {
        this.yq1Options.push({
          label: item.device_id + ',' + item.calibrate_date,
          value: item.device_id + ',' + item.calibrate_date
        })
      })
      let yq2 = await this.$Api.post('get_device_info', {
        'device_name': this.defaultModel.yqmc2
      })
      yq2.forEach(item => {
        this.yq2Options.push({
          label: item.device_id + ',' + item.calibrate_date,
          value: item.device_id + ',' + item.calibrate_date
        })
      })

      let yq3 = await this.$Api.post('get_device_info', {
        'device_name': this.defaultModel.yqmc3
      })
      yq3.forEach(item => {
        this.yq3Options.push({
          label: item.device_id + ',' + item.calibrate_date,
          value: item.device_id + ',' + item.calibrate_date
        })
      })
      let yq4 = await this.$Api.post('get_device_info', {
        'device_name': this.defaultModel.yqmc4
      })
      yq4.forEach(item => {
        this.yq4Options.push({
          label: item.device_id + ',' + item.calibrate_date,
          value: item.device_id + ',' + item.calibrate_date
        })
      })

      let res = await this.$Api.post('get_hw_default', { project_id: this.project_id, site_id: this.site_id })
      if (res) {
        this.defaultModel = res
        if (res.yqbh1 && res.jzyxq1) {
          this.defaultModel.yqbh1jzyxq1 = res.yqbh1 + ',' + res.jzyxq1
        }
        if (res.yqbh2 && res.jzyxq2) {
          this.defaultModel.yqbh2jzyxq2 = res.yqbh2 + ',' + res.jzyxq2
        }
        if (res.yqbh3 && res.jzyxq3) {
          this.defaultModel.yqbh3jzyxq3 = res.yqbh3 + ',' + res.jzyxq3
        }
        if (res.yqbh4 && res.jzyxq4) {
          this.defaultModel.yqbh4jzyxq4 = res.yqbh4 + ',' + res.jzyxq4
        }
      } else {
        if (yq1.length === 1) {
          this.defaultModel.yqbh1jzyxq1 = yq1[0].device_id + ',' + yq1[0].calibrate_date
        }
        if (yq2.length === 1) {
          this.defaultModel.yqbh2jzyxq2 = yq2[0].device_id + ',' + yq2[0].calibrate_date
        }
        if (yq3.length === 1) {
          this.defaultModel.yqbh3jzyxq3 = yq3[0].device_id + ',' + yq3[0].calibrate_date
        }
        if (yq4.length === 1) {
          this.defaultModel.yqbh4jzyxq4 = yq4[0].device_id + ',' + yq4[0].calibrate_date
        }
      }
      this.defaultModel.show = true
    },
    async onSetDefault() {
      try {
        let params = this.defaultModel
        delete params.show
        if (this.defaultModel.yqbh1jzyxq1) {
          let yq_arr = this.defaultModel.yqbh1jzyxq1.split(',')
          params.yqbh1 = yq_arr[0]
          params.jzyxq1 = yq_arr[1]
        }
        if (this.defaultModel.yqbh2jzyxq2) {
          let yq_arr = this.defaultModel.yqbh2jzyxq2.split(',')
          params.yqbh2 = yq_arr[0]
          params.jzyxq2 = yq_arr[1]
        }
        if (this.defaultModel.yqbh3jzyxq3) {
          let yq_arr = this.defaultModel.yqbh3jzyxq3.split(',')
          params.yqbh3 = yq_arr[0]
          params.jzyxq3 = yq_arr[1]
        }
        if (this.defaultModel.yqbh4jzyxq4) {
          let yq_arr = this.defaultModel.yqbh4jzyxq4.split(',')
          params.yqbh4 = yq_arr[0]
          params.jzyxq4 = yq_arr[1]
        }

        delete params.yqbh1jzyxq1
        delete params.yqbh2jzyxq2
        delete params.yqbh3jzyxq3
        delete params.yqbh4jzyxq4
        params.project_id = this.project_id
        params.site_id = this.site_id
        await this.$Api.post('add_hw_default', params)
        this.$message.success("设置成功")
        await this.onCloseDefault()
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    async onCloseDefault() {
      console.log(this.defaultModel.show)
      Object.keys(this.defaultModel).forEach(key => {
        if (key === 'show') {
          this.defaultModel[key] = false
        } else if (key === 'yqmc1') {
          this.defaultModel[key] = '红外热成像仪'
        } else if (key === 'yqmc2') {
          this.defaultModel[key] = '钳形电流表'
        } else if (key === 'yqmc3') {
          this.defaultModel[key] = '数字风速仪'
        } else if (key === 'yqmc4') {
          this.defaultModel[key] = '数字温湿度计'
        } else {
          this.defaultModel[key] = ''
        }
      })
    },
    //获取设备和环境
    async handleGetDefault() {
      try {
        let res = await this.$Api.post('get_hw_default', {
          project_id: this.project_id,
          site_id: this.site_id
        })
        if (res) {
          this.form.hjwd = res.hjwd
          this.form.hjsd = res.hjsd
          this.form.fs = res.fs
          this.form.fsxs = res.fsxs
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //上传成功原图
    async uploadSuccess1(response, file, fileList) {
      this.form.image1_id = response.data.file_id
      this.$message.success("上传成功");
      await this.onEdit()
      await this.getData(this.currentPage)
      // window.location.reload();
    },
    //上传成功红外图
    async uploadSuccess2(response, file, fileList) {
      try {
        this.form.image2_id = response.data.file_id
        this.$message.success("上传成功");
        await this.onEdit()
        await this.getData(this.currentPage)
        // window.location.reload();
      } catch (e) {
        this.$message.error("上传分析图失败:" + (e.errormsg || e.message || '未知错误'));
        console.error("Upload error:", e);
      }
    },
    beforeUpload() {
      if (!this.form.id || this.form.bjcsbmc.length === 0 || this.form.bjcsbwz === 0) {
        this.$message.error("请先保存被检测设备位置和被检测设备名称")
        return false
      }
    },
    //获取所有页码
    async setPages() {
      try {
        this.pages = [];
        let params = {
          project_id: this.project_id,
          site_id: this.site_id,
          zg_type: this.zg_type
        }
        let res = await this.$Api.post('get_max_page', params)
        if (res) {
          this.maxPage = res.max_page
          if (this.maxPage > 0) {
            for (let i = 1; i <= this.maxPage; i++) {
              this.pages.push({ value: i, label: i })
            }
          } else {
            this.pages.push({ value: 1, label: 1 })
          }
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //获取原始记录
    async getData(page) {
      try {
        let params = {
          current_page: page,
          site_id: this.site_id,
          project_id: this.project_id
        }
        let res = await this.$Api.post('get_record_cma_311', params)
        if (res) {
          this.currentPage = res.current_page
          this.image1_src = res.image1_src
          this.image2_src = res.image2_src
          delete res.image1_src
          delete res.image2_src
          this.form = res
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //新增一页
    async initRecord() {
      let params = {
        project_id: this.project_id,
        site_id: this.site_id,
        zg_type: this.zg_type
      }
      let res = await this.$Api.post('get_max_page', params)
      this.currentPage = ++res.max_page;
      delete this.form.id
      this.image1_src = ''
      this.image2_src = ''
      Object.keys(this.form).forEach(key => {
        if (key === 'yqmc1') this.form[key] = '红外热成像仪'
        else if (key === 'yqmc2') this.form[key] = '钳形电流表'
        else if (key === 'yqmc3') this.form[key] = '钳形电流表'
        else if (key === 'yqmc4') this.form[key] = '数字温湿度计'
        else this.form[key] = ''
      })
    },
    //复制上一页数据
    async copyLast() {
      try {
        let res = await this.$Api.post('get_record_cma_311', {
          current_page: this.currentPage - 1,
          site_id: this.site_id,
          project_id: this.project_id
        })
        if (res) {
          delete res.id
          delete res.image1_src
          delete res.image2_src
          res.image1_id = ''
          res.image2_id = ''
          this.form = res
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //删除原始记录
    async handleDel() {
      if (!this.form.id) {
        this.$message.error("当前页没有保存过，不用删除")
        return false
      }
      try {
        let params = {
          id: this.form.id,
          project_id: this.project_id,
          site_id: this.site_id,
          current_page: this.currentPage
        }
        await this.$Api.post('del_record_cma_311', params)
        this.$message.success('删除成功')
        location.reload()
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //切页
    handleChange(page) {
      this.getData(page)
    },
    //提交
    handleSubmit() {
      if (this.form.hasOwnProperty("id")) {
        this.onEdit()
      } else {
        this.onAdd()
      }
    },
    //新增原始记录
    async onAdd() {
      try {
        let params = this.form
        params.site_id = this.site_id
        params.project_id = this.project_id
        params.level = this.level
        await this.$Api.post('add_record_cma_311', params)
        this.$message.success('新增成功')
        location.reload()
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //更新原始记录
    async onEdit() {
      try {
        let params = this.form
        params.project_id = this.project_id
        params.site_id = this.site_id
        params.current_page = this.currentPage
        params.level = this.level
        console.log(params)
        await this.$Api.post('edit_record_cma_311', params)
        this.$message.success('更新成功')
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //设置操作按钮的状态
    async setButtonStatus() {
      try {
        let res = await this.$Api.post('get_site_status', {
          project_id: this.project_id,
          site_id: this.site_id,
          site_type: this.site_type,
          status_type: 'cma'
        })
        if (res) {
          if (res === '检测中' || res === '已完成') {
            this.inspect_status = true
          }
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    }
  },
  filters: {
    yq_spilt1: function (str) {
      let arr = str.split(",")
      return arr[0]
    },
    yq_spilt2: function (str) {
      let arr = str.split(",")
      return arr[1]
    }
  },
  computed: {
    level() {
      if (this.form.jcjg === '温度存在紧急缺陷') {
        return 'A';
      } else if (this.form.jcjg === '温度存在严重缺陷') {
        return 'B'
      } else if (this.form.jcjg === '温度存在一般缺陷') {
        return 'C'
      } else {
        return '--'
      }
    }
  },
  created() {
    this.project_id = this.$route.params.project_id
    this.site_id = this.$route.params.site_id
    this.site_type = this.$route.params.site_type
    this.uploadData.project_id = this.$route.params.project_id
    this.uploadData.site_id = this.$route.params.site_id
    this.setButtonStatus()
    this.setPages()
    this.getData(10000)
  }
}
</script>
<style scoped>
table {
  width: 100%;
}

.inline-block {
  display: inline-block;
  margin-left: 5px;
  margin-right: 5px;
}

table,
table tr td {
  border: 1px solid black;
  border-collapse: collapse;
  text-align: center;
  vertical-align: middle !important;
}
</style>
